var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFBC3B",
    d: "M11.667 7.333a4.333 4.333 0 100 8.667 4.333 4.333 0 000-8.667zm2.466 3.454l-2.098 2.8a1.2 1.2 0 01-.882.481h-.088a1.2 1.2 0 01-.853-.357L9.133 12.63a.667.667 0 01.943-.943l.847.846a.165.165 0 00.25-.018l1.897-2.529a.667.667 0 111.067.8l-.004.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00C1EB",
    d: "M3.05 7.313a4.983 4.983 0 014.429.472.333.333 0 01.076.494 5.307 5.307 0 00-1.134 2.447.333.333 0 01-.328.274H.333a.333.333 0 01-.321-.429 4.983 4.983 0 013.037-3.258zM4.666 0a3.333 3.333 0 110 6.667 3.333 3.333 0 010-6.667zm-1.44 2.639a.333.333 0 00-.494.2 1.885 1.885 0 00-.066.494 2 2 0 003.972.33.333.333 0 00-.38-.376 4.24 4.24 0 01-.619.046 4.64 4.64 0 01-2.413-.694z"
  }))));
}
export default SvgSocial;